














































import { Vue, Component } from 'vue-property-decorator';
import CustomButton from '@/components/Globals/CustomButton.vue';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomModal from '@/components/Modals/wrapper/modalWrapper.vue';
import ModalHeader from '@/components/molecule.modal.header.vue';
import CustomText from "./Globals/CustomText.vue";
import repositionWarning from '@/mixins/UGC/repositionWarning';

@Component({
  components: {
    CustomButton,
    CustomContainer,
    CustomModal,
    ModalHeader,
    CustomText
  },
  mixins: [repositionWarning],
})
export default class UgcRepositionWarning extends Vue {

}
